import React from "react";
import NotFound from "../NotFound";
import { strings } from "../../i18n";
import { useHasAdminGroup } from "../../hooks";

/**
 * Render children only for organisation admins.
 *
 * The nav hides admin screens from everyone else (use-drawer-items.js), but a
 * hidden nav item is not a guard: the route itself stays reachable by URL.
 * Wrap the route in this so the screen checks the same thing the nav does.
 */
export default ({ children }) =>
    useHasAdminGroup() ? (
        children
    ) : (
        <NotFound message={strings("messages.adminOnly")} />
    );
